<template>
    <div :class="{'list-wrapper': true, 'official-issue-list': !islistpage}"
        v-if="Object.keys(listData).length"
        @click="toastNotScroll">
        <div class="list-blue"></div>
        <div class="list-head">
            <h1 class="list-name">已知问题与需求反馈</h1>

            <!-- 技术支持、审核员、管理员角色都可以添加issue -->              
            <veui-button
                v-if="hasOfficialPermission"
                @click="addIssue"
                ui="primary"
                class="list-add-issue">
                添加 Issue
            </veui-button>
        </div>

        <div>
            <div class="center-tab">
                <ul class="center-tab-name">
                    <li :class="{'center-tab-name-item': true, 'center-tab-name-item-active': +tagId === 17}"
                        @click="chooseTab(17)" >
                        已知问题
                    </li>
                    <li :class="{'center-tab-name-item': true, 'center-tab-name-item-active': +tagId === 18}"
                        @click="chooseTab(18)" >
                        需求反馈
                    </li>
                </ul>
            </div>

            <!-- 技术支持、rd审核员、问题管理员、管理员角色都可以 -->
            <topic-filter
                v-if="islistpage && hasOfficialPermission"
                :existloc="'issue'">
            </topic-filter>

            <!-- 非issue列表可以查询 -->
            <issue-filter v-if="!islistpage"
                :process-options="processOptions"
                :page-size="size">
            </issue-filter>

            <div class="f-issue-list-table">
                <veui-table
                    :selectable="selectable"
                    @select="select"
                    :selected="localSelected"
                    :expandable="expandable"
                    :scroll="allowscrollheight"
                    key-field="issueId"
                    :data="listData.topicList">

                    <!-- expandable为true时会增加占位块，影响样式，所以expandable为false时手动添加 -->
                    <veui-table-column v-if="!expandable" width="24px" field="placehold1">
                    </veui-table-column>

                    <veui-table-column width="70px" field="issueId" title="ID">
                        <template slot-scope="{ issueId }">
                            <router-link target="_blank" :to="{name: 'issueContent', params: {issueid: issueId}}">
                                    #{{issueId}}
                            </router-link>
                        </template>
                    </veui-table-column>
                    <veui-table-column field="title" :title="titleColumnHeader">
                        <template slot-scope="{ issueId, title}">
                            <router-link class="list-issue-title" target="_blank"
                                :title="title"
                                :to="{name: 'issueContent', params: {issueid: issueId}}">
                                {{title}}
                            </router-link>
                        </template>
                    </veui-table-column>
                    <veui-table-column width="120px" field="createdTime" title="创建时间" />

                    <!-- 跟进人信息展示，内部权限身份才可看见 -->
                    <veui-table-column
                        v-if="isPc && islistpage
                            && hasOfficialPermission"
                        width="160px" field="ext" title="跟进人">
                        <template slot-scope="{ ext }">
                            <img v-if="ext.issueOfficialInfo.followUserInfo
                                && Object.keys(ext.issueOfficialInfo.followUserInfo).length"
                                :src="ext.issueOfficialInfo.followUserInfo.avatar"
                                class="list-avatar">
                            <span class="list-nickname">
                                {{ext.issueOfficialInfo.followUserInfo.nickname || '无'}}
                            </span>
                        </template>
                    </veui-table-column>

                    <veui-table-column width="140px" field="process" title="状态">
                        <!-- issue列表页才在表头处下拉 -->
                        <div slot="head" v-if="islistpage">
                            <veui-select
                                :value="process"
                                ui="small"
                                :options="processOptions"
                                @change="optionsChange"
                            />
                        </div>
                        <template slot-scope="{ process }">
                            {{process | matchIssueProcess}}
                        </template>
                    </veui-table-column>
                </veui-table>
            </div>
        </div>
        <div class="list-footer" 
            v-if="listData.pageInfo.recordTotal > listData.pageInfo.pageSize">
            <page-component class="list-footer-page" 
                :page-info="listData.pageInfo"
                :nav-method="true"
                @navToPage="navToPage"
                :change-url="false"
            ></page-component>
            <load-more v-if="islistpage"
                class="list-footer-page-more"
                @load="load"
                :pullUpState="listData.pageInfo.pageNo < listData.pageInfo.pageTotal ? 2 : 3"
                selector-id="issueListTop">
            </load-more>
        </div>
    </div>
</template>

<script>
/**
 * @file issue 列表
 *
 * <issue-list @select="select" :selected="selected" :select="[23,24]" selectable></issue-list>
 * 1. 配置 selectable，显示筛选框
 * 2. 事件回调 select(issueItems) {
 *     // issueItems 是 issue 数组
 * }
 * 3. selected 是默认值 传 issueIds 的数组
 * 4. size 列表条数
 *
 * todo: veui 的翻页貌似只能跳路由，现在翻页坏了
 */
import {mapState, mapMutations, mapGetters} from 'vuex';
import {Table, Column, Select, Button} from 'veui';
import TopicFilter from '@/views/components/topic-filter';
import IssueFilter from '@/views/components/issue-filter';
import Page from '@/views/components/page';
import LoadMore from '@/views/components/LoadMore.vue';
import toast from '@/utils/decorate/toast';
import {Tip} from '@/utils/errorCode';
import {notAllowScroll} from '@/utils/decorate/scroll';
import {throttle} from '@/utils/debounceThrottle';

export default {
    data() {
        return {
            // 用来触发 table head 的重新渲染，解决状态选择不生效问题
            expandable: false,
            localSelected: [],
            img: require('@/assets/images/avatar.png')
        };
    },
    props: {
        selectable: {
            'type': Boolean,
            'default': false
        },
        selected: {
            'type': Array,
            'default': () => []
        },
        size: {
            'type': Number,
            'default': 20
        },
        allowscrollheight: {
            'type': Number,
            'default': 0
        },
        islistpage: {
            'type': Boolean,
            'default': false
        }
    },
    components: {
        'topic-filter': TopicFilter,
        'issue-filter': IssueFilter,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-select': Select,
        'veui-button': Button,
        'page-component': Page,
        'load-more': LoadMore
    },
    metaInfo() {
        return {
            title: `${this.metaContentTitle} - 智能小程序开发者社区`,
            meta: [{
                name: 'keywords',
                content: `${this.fixedWords},${this.metaContentTitle}`
            }, {
                name: 'description',
                content: `${this.fixedWords},${this.metaContentTitle}`
            }]
        };
    },
    methods: {
        toastNotScroll() {
            this.$emit('not-scroll');
        },
        getTopicList() {
            if (this.islistpage) {
                const query = {
                    tagId: this.tagId,
                    pageSize: this.size
                };
                if (this.pageNo) {
                    query.pageNo = this.pageNo;
                }
                if (this.process && this.process !== 'ALL') {
                    query.process = this.process;
                }
                this.$store.dispatch('getTopicList', {params: {moduleid: this.issueBoardId}, query});
            }
            else {
                this.$store.dispatch('getOfficialIssueList', this.size)
                    .then(() => {
                        this.localSelected = this.selected.slice(0);
                    });
            }
        },
        optionsChange(process) {
            this.setProcess(process);
            // 用来触发 table head 的重新渲染，解决状态选择不生效问题
            this.expandable = !this.expandable;
            this.setPageNo(1);
            this.$emit('process-change', process);
            this.getTopicList();
        },
        addIssue() {
            if (this.$store.state.header.isLogin) {
                if (this.$store.state.header.isBanned) {
                    toast.error(Tip.banned);
                }
                else {
                    _hmt.push(['_trackEvent', 'operation', '首页发帖按钮点击']);
                    window.open('/forum/topic/add?boardId=6&tagId=17');
                }
            }
            else {
                this.$store.dispatch('navToPassport');
            }
        },
        navToPage(pageNo) {
            this.setPageNo(pageNo);
            this.$emit('page-change', pageNo);
            this.getTopicList();
        },
        chooseTab(tagId) {
            this.setTagId(tagId);
            this.setPageNo(1);
            this.$emit('tag-change', tagId);
            if (this.islistpage) {
                this.setProcess('ALL');
                this.$store.dispatch('clearFilterState');
            }
            else {
                // 官方流程issue
                // 切换tab时清空搜索条件
                this.setIssueFilterProcess('ALL');
                this.setIssueFilterTitle('');
            }
            this.getTopicList();
        },
        select(selected, item, selectedItems) {
            // 表格项选中时会自动为body添加上overflow:visible的属性，强制禁止
            notAllowScroll();

            if (item) {
                this.$emit('select', selected, item, selectedItems);
            }
            else {
                for (let issue of this.listData.topicList) {
                    this.$emit('select', selected, issue, selectedItems);
                }
            }
            if (this.localSelected.length >= 10) {
                this.$nextTick(() => {
                    this.localSelected = this.selected.slice(0);
                });
            }
        },
        reset() {
            this.setPageNo(1);
            this.setTagId(17);
            if (this.islistpage) {
                this.setProcess('ALL');
                this.$store.dispatch('clearFilterState');
            }
            else {
                // 官方流程issue
                // 清空搜索条件
                this.setIssueFilterProcess('ALL');
                this.setIssueFilterTitle('');
            }
        },
        load: throttle(function (type, isPageTurn) {
            if (type === 'more') {
                this.loadMore();
            }
            else {
                this.loadLess(isPageTurn);
            }
        }),
        loadMore() {
            const query = {
                tagId: this.tagId,
                pageSize: this.size
            };
            if (this.pageNo) {
                query.pageNo = this.pageNo;
            }
            if (this.process && this.process !== 'ALL') {
                query.process = this.process;
            }
            this.$store.dispatch('getTopicList', {params: {moduleid: this.issueBoardId}, query, loadMore: true});
        },
        loadLess(isPageTurn) {
            let name = this.$route.name;
            let params = Object.assign({}, this.$route.params);
            let query = Object.assign({}, this.$route.query);
            // 如果是翻页组件，获取当前数据的页码
            if (isPageTurn) {
                // 页码相同不触发 watch，手动请求接口
                if (+query.pageNo === +this.listData.pageInfo.pageNo) {
                    this.$store.dispatch('getTopicList',
                        {params: {moduleid: this.issueBoardId}, query, loadMore: false});
                    return;
                }
                query.pageNo = this.listData.pageInfo.pageNo;
                this.$router.push({name, params, query});
            }
            // 如果是loadMore组件，数据从首页开始
            else {
                query.pageNo = 1;
            }
            this.$store.dispatch('getTopicList', {params: {moduleid: this.issueBoardId}, query, loadMore: false});
        },
        ...mapMutations([
            'setProcess',
            'setTagId',
            'setPageNo',
            'setIssueFilterProcess',
            'setIssueFilterTitle'
        ])
    },
    mounted() {
        this.getTopicList();
    },
    beforeDestroy() {
        this.reset();
    },
    computed: {
        ...mapState({
            issueListData: state => state.list.listData,
            officialIssueToCheckData: state => state.topicContent.issueToCheckData,
            tagId: state => state.list.issueInfo.tagId || 17,
            pageNo: state => state.list.issueInfo.pageNo,
            process: state => state.list.issueInfo.process,
            issueBoardId: state => state.common.issueBoardId,
            bugTagId: state => state.common.bugTagId,
            featherTagId: state => state.common.featherTagId,
            bugProcessOptions: state => state.common.bugProcessOptions,
            featureProcessOptions: state => state.common.featureProcessOptions,
            fixedWords: state => state.common.metaInfo.fixedWords,
            isPc: state => state.common.isPc
        }),
        ...mapGetters([
            'hasOfficialPermission'
        ]),
        listData: {
            get() {
                return this.islistpage ? this.issueListData : this.officialIssueToCheckData;
            }
        },
        titleColumnHeader() {
            return +this.tagId === this.featherTagId ? '具体需求' : '已知问题';
        },
        metaContentTitle() {
            return +this.tagId === this.featherTagId ? '需求反馈' : '已知问题';
        },
        processOptions() {
            return +this.tagId === this.featherTagId ? this.featureProcessOptions : this.bugProcessOptions;
        }
    }
};

</script>

<style lang="less">
    @import '../../../assets/less/views/home/main-content.less';
    @import '../../../assets/less/views/list/list.less';

    .list-wrapper .veui-table td {
        white-space: normal;
        word-break: break-all;
    }

    // expanable为true时首行样式会更改，强行改回来
    .veui-table .veui-table-cell-expand + th,
    .veui-table .veui-table-cell-expand + td {
        padding-left: 16px;
    }

    .official-issue-list {
        & .veui-table th:first-of-type,
        & .veui-table td:first-of-type {
            padding-left: 24px;
        }
    }
</style>
